<template lang="html">
  <div class="calendar-mobile-container px-3 py-2" v-bind:id="id">

    <div class="is-flex is-justify-content-between is-align-items-start mb-3">

      <div class="is-flex is-flex-direction-column">

      <span class="title is-5 has-text-weight-bold is-capitalized m-0 pt-1 is-flex is-align-items-center is-flex-grow-1 calendar-title">
        <i class="fas fa-calendar-alt mr-2 icon-calendar"></i>
        {{ titoloCalendario }}
      </span>

      <div class="field mt-2 mb-0" v-if="listaUtentiDisponibili.length > 0 || utenteSelezionatoId !== undefined">
        <div class="control has-icons-left">
          <div class="select is-small is-custom-select">
            <select v-model="utenteSelezionatoId" class="has-text-dark">

            <option value="MINE">I miei eventi</option>

            <option value="">Tutti </option>
        
            <option 
              v-for="u in listaUtentiDisponibili" 
              :key="u.Id" 
              :value="u.Id"
              >
              {{ u.Name }}
            </option>
            </select>
          </div>

          <div class="icon is-small is-left has-text-dark">
            <i class="fas fa-user-friends"></i>
          </div>
        </div>
      </div>
      
      </div>

      <div class="is-flex-grow-1 is-flex-direction-column mb-3">

      <div class="is-flex is-flex-direction-column is-align-items-end pl-3">
        <div class="buttons has-addons m-0 are-small mb-2">
          <button 
            class="button px-3 btn-toggle" 
            :class="vistaCorrente === 'month' ? 'is-active-btn' : 'is-inactive-btn'" 
            @click="vistaCorrente = 'month'"
          >
            Mese
          </button>
          <button 
            class="button px-3 btn-toggle" 
            :class="vistaCorrente === 'week' ? 'is-active-btn' : 'is-inactive-btn'" 
            @click="vistaCorrente = 'week'"
          >
            Sett.
          </button>
        </div>

        <!-- <div class="buttons are-small m-0"> -->
        <div class="is-flex is-align-items-center gap-1">
        <button 
          class="button is-small px-3 btn-toggle" 
          @click="goToToday">
           Oggi
        </button>
        <button class="button is-small btn-nav px-3" @click="cambiaPeriodo(-1)">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button class="button is-small btn-nav px-3" @click="cambiaPeriodo(1)">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
      </div>
      </div>

    </div>

    <div v-if="vistaCorrente === 'month'" class="columns is-mobile is-gapless mb-1 has-text-centered has-text-weight-semibold is-size-7 text-muted">
      <div class="column is-pure-7">LUN</div>
      <div class="column is-pure-7">MAR</div>
      <div class="column is-pure-7">MER</div>
      <div class="column is-pure-7">GIO</div>
      <div class="column is-pure-7">VEN</div>
      <div class="column is-pure-7">SAB</div>
      <div class="column is-pure-7">DOM</div>
    </div>

    <div v-if="vistaCorrente === 'month'" class="columns is-mobile is-multiline is-gapless month-grid">
  <div 
    v-for="(giorno, index) in giorniDaMostrare" 
    :key="index" 
    class="column is-pure-7 cell-container"
    @click="giorno.isVuoto ? null : selezionaData(giorno.dataCompleta)"
  >
    <div 
      v-if="!giorno.isVuoto"
      class="day-cell is-flex is-flex-direction-column p-1"
      :class="{ 
        'is-active-day': isStessaData(giorno.dataCompleta, dataSelezionata),
        'is-today': giorno.isOggi 
      }"
    >
      <!-- Numero del giorno -->
      <span class="day-number has-text-weight-bold mb-1">{{ giorno.numeroGiorno }}</span>

      <!-- Lista dei primi 3 eventi -->
      <div 
        v-for="(evento, evIndex) in getEventiDellaGiornata(giorno.dataCompleta).slice(0, 3)" 
        :key="evIndex"
        class="event-detail-card p-1 mb-1 rounded text-truncate"
        :style="{
          backgroundColor: getOwnerColor(evento.SalesPaddy_Owner__c || evento.OwnerId),
          borderLeft: '3px solid ' + getOwnerBorderColor(evento.SalesPaddy_Owner__c || evento.OwnerId)
        }"
        @click.stop="apriDettaglioEvento(evento)" 
      >
        <p 
          class="has-text-weight-semibold is-size-7 event-title text-truncate mb-0"
          :style="{ color: getOwnerBorderColor(evento.SalesPaddy_Owner__c || evento.OwnerId) }"
        >
          {{ evento.Titolo_calendario__c || 'Nessun Oggetto' }}
        </p>
      </div>

      <!-- Badge per gli eventi rimanenti (+N) -->
      <div 
        v-if="getEventiDellaGiornata(giorno.dataCompleta).length > 3" 
        class="more-events-badge has-text-weight-bold is-size-7 text-muted px-1 mt-auto"
        @click.stop="vaiAllaSettimana(giorno.dataCompleta)"
      >
        +{{ getEventiDellaGiornata(giorno.dataCompleta).length - 3 }} altri
      </div>

    </div>
    <div v-else class="day-cell-empty"></div>
  </div>
    </div>

    <div v-else class="week-vertical-list">
      <div 
        v-for="(giorno, index) in giorniDaMostrare" 
        :key="index" 
        :id="`colonna-${giorno.numeroGiorno}`"
        class="week-row is-flex is-align-items-start p-2 mb-2"
        :class="{ 
          'is-active-row': isStessaData(giorno.dataCompleta, dataSelezionata),
          'is-today-row': giorno.isOggi 
        }"
        @click="selezionaData(giorno.dataCompleta)"
        >
        <div class="week-date-badge is-flex is-flex-direction-column is-align-items-center is-justify-content-center mr-3">
          <span class="is-size-7 has-text-weight-normal text-muted is-uppercase">{{ giorno.nomeGiornoSettimana }}</span>
          <span class="is-size-5 has-text-weight-bold day-number">{{ giorno.numeroGiorno }}</span>
        </div>

        <div class="week-events-container is-flex-grow-1">
          <div v-if="getEventiDellaGiornata(giorno.dataCompleta).length > 0">
            <div 
              v-for="(evento, evIndex) in getEventiDellaGiornata(giorno.dataCompleta)" 
              :key="evIndex"
              class="event-detail-card p-2 mb-1 rounded"
              :style="{
              backgroundColor: getOwnerColor(evento.SalesPaddy_Owner__c || evento.OwnerId),
               borderLeft: '4px solid ' + getOwnerBorderColor(evento.SalesPaddy_Owner__c || evento.OwnerId)
              }"
              @click.stop="apriDettaglioEvento(evento)" 
              >
              <!-- Titolo Evento con colore dinamico dello stesso tono -->
              <p 
                class="has-text-weight-semibold is-size-7 event-title"
                :style="{ color: getOwnerBorderColor(evento.SalesPaddy_Owner__c || evento.OwnerId) }"
                >
                {{ [evento.Subject, evento.Titolo_visita__c].filter(Boolean).join(' - ') || 'Nessun Oggetto' }}
              </p>

              <!-- Account (Azienda) -->
              <p class="is-size-7 text-muted" v-if="evento.Account?.Name || evento.Account_Name">
                 <i class="far fa-building mr-1"></i>
                {{ evento.Account?.Name || evento.Account_Name }}
              </p>

              <!-- SalesPaddy Owner / Persona -->
              <p class="is-size-7 text-muted" v-if="evento.SalesPaddy_Owner__r?.Name || evento['SalesPaddy_Owner__r.Name']">
                 <i class="far fa-user mr-1"></i>
                {{ evento.SalesPaddy_Owner__r?.Name || evento['SalesPaddy_Owner__r.Name'] }}
              </p>
            </div>

          </div>
          <div v-else class="text-empty-state is-size-7 pt-2 italic">
            Nessun evento
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'bulmaCalendar',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      listaUtentiDisponibili: [],
      eventsLocali: []
    }
  },
  computed: {
    vistaCorrente: {
      get() {
        return this.$store.state.calendario?.[this.id]?.vista || 'month';
      },
      set(nuovaVista) {
        this.$store.commit('SET_CALENDARIO_STATO', { id: this.id, chiave: 'vista', valore: nuovaVista });
      }
    },
    dataAncoraggio: {
      get() {
        const d = this.$store.state.calendario?.[this.id]?.dataAncoraggio;
        return d ? new Date(d) : new Date();
      },
      set(nuovaData) {
        this.$store.commit('SET_CALENDARIO_STATO', { id: this.id, chiave: 'dataAncoraggio', valore: nuovaData });
      }
    },
    dataSelezionata: {
      get() {
        const d = this.$store.state.calendario?.[this.id]?.dataSelezionata;
        return d ? new Date(d) : new Date();
      },
      set(nuovaData) {
        this.$store.commit('SET_CALENDARIO_STATO', { id: this.id, chiave: 'dataSelezionata', valore: nuovaData });
      }
    },
    utenteSelezionatoId: {
      get() {
        return this.$store.state.calendario?.[this.id]?.utenteSelezionatoId ?? 'MINE';
      },
      set(nuovoUtente) {
        this.$store.commit('SET_CALENDARIO_STATO', { id: this.id, chiave: 'utenteSelezionatoId', valore: nuovoUtente });
      }
    },
    config() {
      const obj = this.$store.getters.getObject(this.id);
      return obj && obj.data ? obj.data : {};
    },
    editmode() {
      return this.$store.getters.getEditMode(this.id);
    },
    titoloCalendario() {
      return this.dataAncoraggio.toLocaleString('it-IT', { month: 'long', year: 'numeric' });
    },
    giorniDaMostrare() {
      if (this.vistaCorrente === 'month') {
        return this.generaMese();
      } else {
        return this.generaSettimana();
      }
    },
    eventiFiltrati() {
      const listaEventi = this.eventsLocali || [];
      const currentUser = this.$store.state.overrideUser ? this.$store.state.overrideUser : this.$store.state.myprofile.contactId;
      //const currentKey = this.$store.state.overrideKey ? this.$store.state.overrideKey : this.$store.state.myprofile.contactKey;
  

      if (!this.utenteSelezionatoId) {
        return listaEventi;
      }

      if (this.utenteSelezionatoId === 'MINE') {
        return listaEventi.filter(ev => {
          const owner = ev.SalesPaddy_Owner__c 
          return owner === currentUser;
        });
      }

      return listaEventi.filter(ev => {
        const owner = ev.SalesPaddy_Owner__c ;
        return owner === this.utenteSelezionatoId;
      });
    }
  },
  watch: {
    dataAncoraggio() {
      this.loadRows();
    },
    vistaCorrente() {
      this.loadRows();
    },
    config: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.loadRows();
        }
      }
    }
  },
  mounted() {
    this.loadRows();
    this.caricaUtentiGerarchiaJS();
  },
  activated() {
    this.loadRows();
    this.ripristinaScrollSettimana();
  },
  methods: {
    async caricaUtentiGerarchiaJS() {
  const currentUser = this.$store.state.overrideUser ? this.$store.state.overrideUser : this.$store.state.myprofile.contactId;
  //const currentKey = this.$store.state.overrideKey ? this.$store.state.overrideKey : this.$store.state.myprofile.contactKey;
  const storeKeyContacts = this.id + '_contacts';
  const storeKeyRoles = this.id + '_roles';

  try {
    const payloadContacts = {
      id: storeKeyContacts,
      object: 'Contact',
      properties: ['Id', 'Name','SalesPaddy_Key__c' ,'SalesPaddy_Username__c', 'Business_Role__c', 'Business_Role__r.Report_To__c'],
      filters: [
        {"fieldname": "SalesPaddy_Username__c", "operator": "NEQ", "value": ""},
        {"fieldname": "Business_Role__c", "operator": "NO_STRING_NEQ", "value": "null"},
      ]
    };

    const payloadRoles = {
      id: storeKeyRoles,
      object: 'Business_Role__c',
      properties: ['Id', 'Report_To__c'],
      filters: []
    };

    console.log('PAYLOAD CARICAMENTO GERARCHIA CONTATTI E RUOLI');
    
    await Promise.all([
      this.$store.dispatch('search_records', payloadContacts),
      this.$store.dispatch('search_records', payloadRoles)
    ]);

    const dataContatti = this.$store.getters.getRecordsList(storeKeyContacts);
    const dataRuoli = this.$store.getters.getRecordsList(storeKeyRoles);

    const tuttiContatti = dataContatti?.records || [];
    const tuttiRuoli = dataRuoli?.records || [];

    //console.log("tuttiContatti:", tuttiContatti);
    //console.log("tuttiRuoli:", tuttiRuoli);

    if (tuttiContatti.length === 0 || tuttiRuoli.length === 0) {
      this.listaUtentiDisponibili = [];
      return;
    }

    //const mioContatto = tuttiContatti.find(c => c.SalesPaddy_Username__c === currentUser);
    const mioContatto = tuttiContatti.find(c => c.Id === currentUser);
    console.log("mioContatto --> ",mioContatto);
    const mioBusinessRole = mioContatto?.Business_Role__c;

    if (!mioBusinessRole) {
      console.warn("Impossibile trovare il Business Role per l'utente corrente:", currentUser);
      this.listaUtentiDisponibili = [];
      return;
    }

    const mappaRuoliFigli = new Map();
    tuttiRuoli.forEach(r => {
      const padreId = r.Report_To__c;
      const ruoloId = r.Id;

      if (padreId && ruoloId) {
        if (!mappaRuoliFigli.has(padreId)) {
          mappaRuoliFigli.set(padreId, new Set());
        }
        mappaRuoliFigli.get(padreId).add(ruoloId);
      }
    });

    const ruoliSubordinati = new Set();
    let ruoliDaEsplorare = [mioBusinessRole];

    while (ruoliDaEsplorare.length > 0) {
      const prossimiRuoli = [];

      for (const ruoloId of ruoliDaEsplorare) {
        if (mappaRuoliFigli.has(ruoloId)) {
          for (const figlioId of mappaRuoliFigli.get(ruoloId)) {
            if (!ruoliSubordinati.has(figlioId)) {
              ruoliSubordinati.add(figlioId);
              prossimiRuoli.push(figlioId);
            }
          }
        }
      }

      ruoliDaEsplorare = prossimiRuoli;
    }

    //console.log("Ruoli subordinati trovati nella gerarchia:", Array.from(ruoliSubordinati));

    this.listaUtentiDisponibili = tuttiContatti.filter(c => ruoliSubordinati.has(c.Business_Role__c)).sort((a, b) => (a.Name || '').localeCompare(b.Name || ''));;
    //console.log("listaUtentiDisponibili finale:", this.listaUtentiDisponibili);

  } catch (error) {
    console.error("Errore nel caricamento della gerarchia Contatti:", error);
    this.listaUtentiDisponibili = [];
  }
},
    async loadRows() {
      if (!this.config) return;
      console.log('--> loadRows (bulma_calendar)');

      let inizioISO = '';
      let fineISO = '';

      if (this.vistaCorrente === 'month') {
        const anno = this.dataAncoraggio.getFullYear();
        const mese = this.dataAncoraggio.getMonth();

        const inizioMese = new Date(Date.UTC(anno, mese, 1, 0, 0, 0));
        const fineMese = new Date(Date.UTC(anno, mese + 1, 0, 23, 59, 59));

        inizioISO = inizioMese.toISOString();
        fineISO = fineMese.toISOString();
      } else {
        // Vista Settimana
        const dataCorrente = new Date(this.dataAncoraggio);
        const giornoSettimana = dataCorrente.getDay();
        const offsetAlLunedi = giornoSettimana === 0 ? -6 : 1 - giornoSettimana;

        const lunedi = new Date(dataCorrente);
        lunedi.setDate(dataCorrente.getDate() + offsetAlLunedi);
        lunedi.setHours(0, 0, 0, 0);

        const domenica = new Date(lunedi);
        domenica.setDate(lunedi.getDate() + 6);
        domenica.setHours(23, 59, 59, 999);

        inizioISO = lunedi.toISOString();
        fineISO = domenica.toISOString();
      }

      const dateField = this.config.date_field || 'StartDateTime';

      var payload = {
        id: this.id, 
        object: this.config.table ? this.config.table : 'Event', 
        properties: ['Id', 'Subject', 'Titolo_visita__c' ,'Titolo_calendario__c','StartDateTime', 'Account.Name','SalesPaddy_Owner__c', 'SalesPaddy_Owner__r.Name'],
        filters: [
          {
          "fieldname": dateField,
          "operator": "GTE",
          "value": inizioISO
          },
          {
          "fieldname": dateField,
          "operator": "LTE", 
          "value": fineISO
          }
        ]
      };

      console.log('PAYLOAD CALENDAR CON FILTRO DATE', payload);

      try {
        await this.$store.dispatch('search_records', payload);
        let dataStato = this.$store.getters.getRecordsList(this.id);

        if (dataStato && dataStato.records) {
          this.eventsLocali = dataStato.records; 
        } else {
          this.eventsLocali = [];
        }
      } catch (error) {
        console.error("Errore nel caricamento dei dati del calendario:", error);
      }
    
    },

    ripristinaScrollSettimana() {
  if (this.vistaCorrente !== 'week') return;

  const dataTarget = this.dataSelezionata || this.dataAncoraggio;
  if (!dataTarget) return;

  const d = new Date(dataTarget);
  if (isNaN(d.getTime())) return;

  const numeroGiorno = d.getDate();

  this.$nextTick(() => {
    const el = document.getElementById(`colonna-${numeroGiorno}`);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  });
    },
    goToToday() {
  const oggi = new Date();
  
  this.dataSelezionata = oggi;
  this.dataAncoraggio = oggi; 

  if (this.vistaCorrente === 'week') {
    const numeroGiorno = oggi.getDate();
    
    this.$nextTick(() => {
      const el = document.getElementById(`colonna-${numeroGiorno}`);
      if (el) {
        el.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start' 
        });
      }
    });
  }
    },
    getEventiDellaGiornata(data) {
      const sorgenteDati = this.eventiFiltrati;
      if (!data || !sorgenteDati || !Array.isArray(sorgenteDati)) return [];

      return sorgenteDati.filter(evento => {
        const dataEventoRaw = evento.StartDateTime || evento.ActivityDate; 
        if (!dataEventoRaw) return false;

        const dEvento = new Date(dataEventoRaw);
        if (isNaN(dEvento.getTime())) return false; 

        return this.isStessaData(data, dEvento);
      });
    },

    notificaRichiestaDati() {
      const anno = this.dataAncoraggio.getFullYear();
      const mese = String(this.dataAncoraggio.getMonth() + 1).padStart(2, '0');
      
      this.$emit('fetch-events', {
        id: this.id,
        table: 'Event',
        anno: anno,
        mese: mese,
        dataAncoraggio: this.dataAncoraggio,
        vista: this.vistaCorrente
      });
    },

    isStessaData(d1, d2) {
      if (!d1 || !d2) return false;
      return d1.getDate() === d2.getDate() &&
             d1.getMonth() === d2.getMonth() &&
             d1.getFullYear() === d2.getFullYear();
    },

   generaMese() {
      const giorni = [];
      const anno = this.dataAncoraggio.getFullYear();
      const mese = this.dataAncoraggio.getMonth();

      const primoGiornoMese = new Date(anno, mese, 1);
      const ultimoGiornoMese = new Date(anno, mese + 1, 0);

      let primoGiornoSettimana = primoGiornoMese.getDay();
      let offsetIniziale = primoGiornoSettimana === 0 ? 6 : primoGiornoSettimana - 1;

      for (let i = 0; i < offsetIniziale; i++) {
        giorni.push({ isVuoto: true });
      }

      const oggi = new Date();
      const totaleGiorni = ultimoGiornoMese.getDate();

      for (let numGiorno = 1; numGiorno <= totaleGiorni; numGiorno++) {
        const d = new Date(anno, mese, numGiorno);
        giorni.push({
          isVuoto: false,
          numeroGiorno: numGiorno,
          dataCompleta: d,
          isOggi: this.isStessaData(d, oggi)
        });
      }
      return giorni;
    },

    generaSettimana() {
      const giorni = [];
      const oggi = new Date();
      
      const dataCorrente = new Date(this.dataAncoraggio);
      const giornoSettimana = dataCorrente.getDay(); 
      const offsetAlLunedi = giornoSettimana === 0 ? -6 : 1 - giornoSettimana;
      
      const lunediCorrente = new Date(dataCorrente);
      lunediCorrente.setDate(dataCorrente.getDate() + offsetAlLunedi);

      for (let i = 0; i < 7; i++) {
        const d = new Date(lunediCorrente);
        d.setDate(lunediCorrente.getDate() + i);
        
        giorni.push({
          isVuoto: false,
          numeroGiorno: d.getDate(),
          nomeGiornoSettimana: d.toLocaleString('it-IT', { weekday: 'short' }).replace('.', ''), 
          dataCompleta: d,
          isOggi: this.isStessaData(d, oggi)
        });
      }
      return giorni;
    },

    cambiaPeriodo(direzione) {
      const nuovaData = new Date(this.dataAncoraggio);
      if (this.vistaCorrente === 'month') {
        nuovaData.setMonth(nuovaData.getMonth() + direzione);
      } else {
        nuovaData.setDate(nuovaData.getDate() + (direzione * 7));
      }
      this.dataAncoraggio = nuovaData;

    },

    selezionaData(data) {
  this.dataSelezionata = data;
  this.dataAncoraggio = data;

  const annoStr = data.getFullYear();
  const meseStr = String(data.getMonth() + 1).padStart(2, '0');
  const giornoStr = String(data.getDate()).padStart(2, '0');
  const dataFormattata = `${annoStr}-${meseStr}-${giornoStr}`;

  if (this.config && this.config.action) {
    let m = {
      message: this.config.action, 
      process: this.config.process,
      verb: this.config.verb,
      payload: {
        id: this.id,
        process: this.config.process,
        verb: this.config.verb,
        selected_date: dataFormattata,
        StartDateTime1: `${dataFormattata}T09:00`, 
        EndDateTime1: `${dataFormattata}T10:00`,
        defaults: [
          { fieldname: "StartDateTime", previous: "StartDateTime1" }, 
          { fieldname: "EndDateTime", previous: "EndDateTime1" }     
        ]
      }
    };

    console.log('POST_MESSAGE - Nuovo Evento (Inserimento):', m);
    this.$store.commit('POST_MESSAGE', m);
  }
    },

    apriDettaglioEvento(evento) {
      if (!evento || !evento.Id || !this.config) return;

      const dataEvento = evento.StartDateTime || evento.ActivityDate;

      if (dataEvento) {
        const d = new Date(dataEvento);
        if (!isNaN(d.getTime())) {
          this.dataSelezionata = d;
        }
      }

      const nomeProcesso = this.config.process_edit || this.config.process;

      this.$store.commit('SET_RECORDS_STATE', { id: nomeProcesso, state: 'EDIT' });
      this.$store.commit('SET_RECORDS_ID', { id: nomeProcesso, data: evento.Id });

      const urlDestinazione = `/${nomeProcesso}/d/${evento.Id}`;
      this.$router.push(urlDestinazione);
    },

    formattaOra(dataString) {
      if (!dataString) return '';
      const d = new Date(dataString);
      if (isNaN(d.getTime())) return dataString; 
      return d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
    },

    getOwnerColor(ownerId) {
    if (!ownerId) return '#e2e8f0'; // Colore grigio di default se manca l'owner

    let hash = 0;
    for (let i = 0; i < ownerId.length; i++) {
      hash = ownerId.charCodeAt(i) + ((hash << 5) - hash);
    }

    const hue = (Math.abs(hash) * 137.5) % 360;
    return `hsl(${hue}, 45%, 88%)`; 
    },

    // Genera un colore più scuro per il bordo
    getOwnerBorderColor(ownerId) {
    if (!ownerId) return '#64748b';
    
    let hash = 0;
    for (let i = 0; i < ownerId.length; i++) {
      hash = ownerId.charCodeAt(i) + ((hash << 5) - hash);
    }

    const hue = (Math.abs(hash) * 137.5) % 360;
    return `hsl(${hue}, 70%, 45%)`;
    },

    vaiAllaSettimana(dataSelezionata) {
  const dataTarget = new Date(dataSelezionata);
  
  const numeroGiorno = dataTarget.getDate();

  this.dataAncoraggio = dataTarget; 
  this.dataSelezionata = dataTarget;
  this.vistaCorrente = 'week'; 

  this.$nextTick(() => {
    const el = document.getElementById(`colonna-${numeroGiorno}`);
    if (el) {
      el.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  });
    }

  }
}
</script> 

<style scoped>

.calendar-mobile-container {

  --bg-main: #ffffff; /* Sfondo bianco */
  --bg-cell: #f6f5f5; /* Celle chiare */
  --bg-row: #fdfdfd; /* Righe settimanali chiare */
  --bg-badge: #f1f3f4; /* Badge chiaro */
  --bg-card: #eff2ff; /* Card eventi celestino chiaro */
  --border-color: #f0f0f0; /* Bordi chiari */
  --text-main: #1d2124; /* Testi principali scuri */
  --text-muted: #6c757d; /* Testi secondari grigio scuro */
  --text-card: #4258ff; /* Testo dell'evento blu */
  --accent: #4258ff;
  --accent-light: #f4f6ff;

  background-color: var(--bg-main);
  border-bottom: 1px solid var(--border-color);
  color: var(--text-main);
}

@media (prefers-color-scheme: dark) {
.calendar-mobile-container {
  --bg-main: #ffffff; /* Sfondo bianco */
  --bg-cell: #f6f5f5; /* Celle chiare */
  --bg-row: #fdfdfd; /* Righe settimanali chiare */
  --bg-badge: #f1f3f4; /* Badge chiaro */
  --bg-card: #eff2ff; /* Card eventi celestino chiaro */
  --border-color: #f0f0f0; /* Bordi chiari */
  --text-main: #1d2124; /* Testi principali scuri */
  --text-muted: #6c757d; /* Testi secondari grigio scuro */
  --text-card: #4258ff; /* Testo dell'evento blu */
  --accent: #4258ff;
  --accent-light: #f4f6ff;
}
}

.theme-dark .calendar-mobile-container,
  [data-theme="dark"] .calendar-mobile-container {
  --bg-main: #ffffff;
  --bg-cell: #f6f5f5;
  --bg-row: #fdfdfd;
  --bg-badge: #f1f3f4;
  --bg-card: #eff2ff;
  --border-color: #f0f0f0;
  --text-main: #1d2124;
  --text-muted: #6c757d;
  --text-card: #4258ff;
}

.calendar-title {
  color: var(--text-main);
}
.icon-calendar {
  color: var(--accent);
}
.text-muted {
  color: var(--text-muted);
}
.text-empty-state {
  color: var(--text-muted);
}

/* Bottoni di navigazione e toggle vista */
.btn-toggle, .btn-nav {
  background-color: var(--bg-cell);
  border-color: var(--border-color);
  color: var(--text-main);
}
.is-active-btn {
  background-color: var(--accent) !important;
  color: #ffffff !important;
}

/* Griglia del mese */
.month-grid {
  display: flex;
  flex-wrap: wrap;
}
.is-pure-7 {
  width: calc(100% / 7) !important;
  flex: none;
}
.cell-container {
  padding: 4px 2px !important;
}
/* Assicura che la cella del giorno occupi l'altezza corretta */
.day-cell {
  height: 100%;
  min-height: 100px; 
  overflow: hidden;
  background-color: #fdfdfd;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  transition: all 0.2s ease;
}

/* Evita che il testo vada a capo rompendosi */
.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.event-detail-card {
  font-size: 0.7rem;
  line-height: 1.2;
  cursor: pointer;
}

.more-events-badge {
  font-size: 0.68rem;
  color: #64748b;
  background: #f1f5f9;
  border-radius: 3px;
  text-align: center;
}

.day-cell-empty {
  height: 100%;
  min-height: 100px; 
}
.day-number {
  font-size: 0.95rem;
}

/* Giorno Selezionato Attivo (Rimane sempre evidente) */
.is-active-day {
  background-color: var(--accent) !important;
  color: #ffffff !important;
  box-shadow: 0 3px 8px rgba(66, 88, 255, 0.3);
}
.is-active-day .day-number {
  color: #ffffff !important;
}

/* Giorno Oggi */
.is-today:not(.is-active-day) {
  border: 1px solid var(--accent);
  background: var(--bg-main);
  color: var(--accent);
}

.badge-dot {
  width: 4px;
  height: 4px;
  background-color: #ff3860;
  border-radius: 50%;
  position: absolute;
  bottom: 4px;
}
.is-active-day .badge-dot {
  background-color: #ffffff;
}

/* Lista della settimana */
.week-vertical-list {
  display: flex;
  flex-direction: column;
}
.week-row {
  background: var(--bg-row);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s ease;
}
.week-date-badge {
  background: var(--bg-badge);
}

/* Riga settimanale selezionata */
.week-row.is-active-row {
  border-color: var(--accent);
  background: var(--accent-light);
}
.week-row.is-active-row .week-date-badge {
  background: var(--accent);
  color: #ffffff;
}
.week-row.is-active-row .week-date-badge * {
  color: #ffffff;
}
.week-row.is-today-row {
  border-left: 4px solid var(--accent);
}

/* Card degli eventi */
.event-detail-card {
  background-color: var(--bg-card);
  border-radius: 6px;
  border-left: 3px solid var(--accent);
}
.event-title {
  color: var(--text-card);
}
.italic {
  font-style: italic;
}
.admin-panel {
  border: 1px dashed #ffdd57;
  border-radius: 8px;
}
.gap-1 {
  gap: 0.35rem;
}
/* Styling della select per sfondo grigio e testo nero */
.select.is-custom-select select {
  background-color: #f5f5f5 !important; /* Grigio chiaro Bulma */
  color: #363636 !important;            /* Testo scuro/nero */
  border-color: #dbdbdb;                /* Bordo grigio chiaro */
}

/* Freccia a destra della select scura */
.select.is-custom-select::after {
  border-color: #363636 !important;
}

/* Mantiene lo stile quando la select è cliccata/focalizzata */
.select.is-custom-select select:focus,
.select.is-custom-select select:active {
  background-color: #eeeeee !important;
  color: #363636 !important;
  border-color: #b5b5b5 !important;
  box-shadow: 0 0 0 0.125em rgba(54, 54, 54, 0.1) !important;
}

/* Opzioni interne con sfondo neutro */
.select.is-custom-select select option {
  background-color: #ffffff;
  color: #363636;
}
</style> 

